import {
    AnimationBaseController,
    AnimationClipContainer,
    Collisions,
    GameRandom,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { RoomModel } from '../../../Models/Game/RoomModel';
import { EnvironmentModel } from '../../../Models/Game/EnvironmentModel';
import { MiniGameModel, MiniGameTypeEnum } from '../../../Models/Game/MiniGameModel';
import { GameModel } from '../../../Models/Game/GameModel';
import { BonusModel } from '../../../Models/Game/BonusModel';
import { BorderModel } from '../../../Models/Game/BorderModel';

export class RoomController extends AnimationBaseController {
    $model: RoomModel;

    public constructor(@Inject private _options,
                       @Inject private _gameModel: GameModel,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _random: GameRandom,
                       @Inject private _collisions: Collisions) {
        super('RoomController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            childControllers: {},
            modelWatch: {
                pos: (pos: [number, number]) => {
                    this.x = pos[0];
                    this.y = pos[1];
                },
                visible: (visible: boolean) => {
                    this.visible = visible;
                },
                x: (x: number) => {
                },
                y: (y: number) => {
                    this.setTextByQuery('index_text', `${this.$model.index}[${this.$model.x},${this.$model.y}]`);
                },
            },
        };
    }

    protected onInitialize(): void {
        this.x = this.$model.pos[0];
        this.y = this.$model.pos[1];

        this.visible = this.$model.visible;
        this.setTextByQuery('index_text', '');

        this.createCollisions();
        this.createRoom();
    }

    private createRoom(): void {
        this.getCurrentAnimationClipChildren(displayObject => {
            if (displayObject instanceof AnimationClipContainer) {
                let animationClip: AnimationClipContainer = displayObject;

                if (animationClip.name.indexOf('stand_flyers_symbol') >= 0) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.stand_flyers);

                } else if (animationClip.name.indexOf('print_card_symbol') >= 0) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.print_card);

                } else if (animationClip.name.indexOf('dinner_symbol') >= 0) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.dinner);

                } else if (animationClip.name.indexOf('bussines_trip_symbol') >= 0) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.bussines_trip);

                } else if (animationClip.name.indexOf('currency_exchange_symbol') >= 0) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.currency_exchange);

                } else if (animationClip.name.indexOf('approve_the_loan_symbol') >= 0) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.approve_the_loan);

                } else if (animationClip.name.indexOf('block_cards_symbol') >= 0) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.block_cards);

                } else if (animationClip.name.indexOf('lock_cell_symbol') >= 0) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.lock_cell);

                } else if (animationClip.name.indexOf('send_a_letter_symbol') >= 0) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.send_a_letter);

                } else if (animationClip.name.indexOf('electricity_symbol') >= 0) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.electricity);

                } else if (animationClip.name.indexOf('bonus') >= 0) {
                    this.addBonus(animationClip);

                } else if (animationClip.name.indexOf('environment') >= 0) {
                    this.addEnvironment(animationClip);

                } else if (animationClip.name.indexOf('border') >= 0) {
                    this.addBorder(animationClip);
                }
            }
        });
    }

    private addEnvironment(animationClip: AnimationClipContainer): EnvironmentModel {
        this.createEnvironmentCollisions(animationClip);

        let type = '';

        this.getCurrentSprites((sprite) => {
            type = sprite.name;
        }, animationClip.name);

        animationClip.visible = false;

        return this.$model.addEnvironment([animationClip.x, animationClip.y], animationClip.name, type);
    }

    private addMiniGame(animationClip: AnimationClipContainer, type: MiniGameTypeEnum): MiniGameModel {
        this.createMiniGameCollisions(animationClip);

        animationClip.visible = false;

        const teleport = animationClip.getChildByQuery('teleport')[0];

        return this.$model.addMiniGame(
            [animationClip.x, animationClip.y],
            [teleport.x, teleport.y],
            animationClip.name,
            type,
        );
    }

    private addBonus(animationClip: AnimationClipContainer): BonusModel {
        let type = '';

        this.getCurrentSprites((sprite) => {
            type = sprite.name;
        }, animationClip.name);

        animationClip.visible = false;

        return this.$model.addBonus([animationClip.x, animationClip.y], animationClip.name, type.replace('bonus_', ''), this.$model.index);
    }

    private createCollisions(): void {
        this.getCurrentPointsPaths((x, y, paths, shapeContainer, shape) => {
            shapeContainer.visible = false;

            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];
                if (path[0][0] == path[path.length - 1][0] &&
                    path[0][1] == path[path.length - 1][1]) {
                    this._collisions.createPolygon(this.x + x, this.y + y, path);

                } else {
                    for (let j = 0; j < path.length - 1; j++) {
                        this._collisions.createPolygon(this.x + x, this.y + y, [path[j], path[j + 1]]);
                    }
                }

            }
        }, 'collisions');
    }

    private createEnvironmentCollisions(animationClip: AnimationClipContainer): void {
        this.getCurrentPointsPaths((x, y, paths, shapeContainer, shape) => {
            shapeContainer.visible = false;

            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];

                for (let j = 0; j < path.length - 1; j++) {
                    this._collisions.createPolygon(this.x + animationClip.x + x, this.y + animationClip.y + y, [path[j], path[j + 1]]);
                }

            }
        }, `${animationClip.name}`);
    }

    private createMiniGameCollisions(animationClip: AnimationClipContainer): void {
        this.getCurrentPointsPaths((x, y, paths, shapeContainer, shape) => {
            shapeContainer.visible = false;

            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];

                for (let j = 0; j < path.length - 1; j++) {
                    this._collisions.createPolygon(this.x + animationClip.x + x, this.y + animationClip.y + y, [path[j], path[j + 1]]);
                }

            }
        }, `${animationClip.name}.collisions`);
    }

    private addBorder(animationClip: AnimationClipContainer): BorderModel {
        let type = '';

        this.getCurrentSprites((sprite) => {
            type = sprite.name;
        }, animationClip.name);

        animationClip.visible = false;

        return this.$model.addBorder([animationClip.x, animationClip.y], animationClip.name, this.$model.index);
    }
}

